<template>
  <v-menu
    v-if="mode === 'button'"
    v-model="localeMenu"
    absolute
    offset-y
    close-on-content-click
    style="max-width: 150px"
  >
    <template #activator="{ on }">
      <v-btn
        v-if="supportedLocales"
        x-small
        fab
        color="rgb(255, 255, 255, 0.25)"
        v-on="on"
        class="localeSwitch"
      >
        {{ currentLocaleItem.flag }}
      </v-btn>
    </template>
    <v-list v-if="supportedLocales" dense>
      <v-list-item-group v-model="currentLocaleForTranslation" mandatory>
        <LocaleSwitchLocaleItem
          v-for="item in supportedLocales"
          :key="item.lang"
          :item="item"
        />
      </v-list-item-group>
    </v-list>
  </v-menu>
  <Select
    dense
    :clearable="false"
    v-else-if="mode === 'select'"
    :items="supportedLocales"
    item-value="lang"
    style="max-width: 250px;"
    v-model="currentLocaleForTranslation"
  >
    <template #selection="{ item }">
      <LocaleItem :item="item" />
    </template>
    <template #item="{ item }">
      <LocaleItem :item="item" />
    </template>
  </Select>
  <div v-else></div>
</template>

<script>
import { find } from 'lodash';
import LocaleSwitchLocaleItem from './LocaleSwitchLocaleItem.vue';
import LocaleItem from '@/components/select/LocaleItem.vue';
import availableLocales from '@/mixins/availableLocales';

export default {
  mixins: [availableLocales],
  components: {
    LocaleItem,
    LocaleSwitchLocaleItem,
  },
  props: {
    mode: {
      type: String,
      default: 'button',
      validator(v) {
        return ['button', 'select'].includes(v);
      },
    },
  },
  data: () => ({
    localeMenu: false,
  }),
  computed: {
    currentLocaleForTranslation: {
      get() {
        return this.$i18n.locale;
      },
      set(locale) {
        this.switchLocale(locale);
      },
    },
    currentLocaleItem() {
      return find(
        this.supportedLocales, 
        x => 
          x.lang === this.currentLocaleForTranslation ||
          x.lang === this.currentLocaleForTranslation.split('-')[0] //don't need exact match. en-US shoud still return en item
      ) || {};
    },
  },
  methods: {
    switchLocale(locale) {
      this.$locale(locale); // set in $i18n
      this.$store.dispatch('user/setLocale', locale); // set user setting
    },
  },
};
</script>

<style>
.localeSwitch > .v-btn__content {
  font-size: 1.5em;
}
</style>
